// extracted by mini-css-extract-plugin
module.exports = {"root":"carousel_root_2cf9V","outside":"carousel_outside_1eWHk","imgout":"carousel_imgout_1svHG","img2":"carousel_img2_gdSr_","bg":"carousel_bg_2OtJk","co":"carousel_co_TMMOB"};